import { render, staticRenderFns } from "./_form.data-loader.page.vue?vue&type=template&id=03814a0a&scoped=true&"
import script from "./_form.data-loader.page.vue?vue&type=script&lang=js&"
export * from "./_form.data-loader.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.data-loader.page.vue?vue&type=style&index=0&id=03814a0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03814a0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VIcon,VSelect,VTextField})
